import PaymentItem from "./PaymentItem";

const PaymentItems = ({ items, handleSelect, selectedMethod }) => {
  return items.map((method) => {
    return (
      <PaymentItem
        key={method.name}
        method={method}
        handleSelect={handleSelect}
        selected={selectedMethod === method.name}
      />
    );
  });
};

export default PaymentItems;
